import React from 'react';
import { Outlet } from 'react-router-dom';

import { Content, Header, Heading, SidebarTrigger } from '@eluve/components';
import { TabNav } from '@eluve/smart-blocks';

export const TenantSettingsMainLayout: React.FC = () => {
  return (
    <>
      <Header>
        <SidebarTrigger />
        <Heading className="sm:pl-2">Organization Settings</Heading>
      </Header>
      <Content size="xl">
        <TabNav
          tabs={[
            {
              link: 'general',
              name: 'General',
            },
            {
              link: 'users',
              name: 'Users',
            },
            {
              link: 'session-types',
              name: 'Session Types',
              featureFlag: 'SESSION_TYPES',
            },
            {
              link: 'layers',
              name: 'Layers',
              featureFlag: 'LOCATIONS',
            },
            {
              link: 'locations',
              name: 'Locations',
              featureFlag: 'LOCATIONS',
            },
            {
              link: 'user-groups',
              name: 'User Groups',
              featureFlag: 'USER_GROUPS',
            },
          ]}
        />
        <Outlet />
      </Content>
    </>
  );
};
